// src/services/synsbasenApi.js
// Opslaget sker i backend, så Synsbasen-nøglen ikke ligger i browseren
import axios from 'axios';

export const fetchVehicleData = async (registrationNumber) => {
  try {
    const reg = encodeURIComponent(registrationNumber.replace(/\s+/g, '').toUpperCase());
    const response = await axios.get(`/api/vehicle/${reg}`);
    return response.data;
  } catch (error) {
    console.error('Fejl ved hentning af køretøjsdata:', error);
    throw new Error('Kunne ikke hente køretøjsdata. Kontroller nummerpladen og prøv igen.');
  }
};
